
import StandardLayout from './Standard/Standard'



export const Standard = StandardLayout

